import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Track page views
export const usePageTracking = (pageName) => {
    useEffect(() => {
        const trackPageView = async () => {
            try {
                await axios.post(`${API}/analytics/page-view`, {
                    page: pageName,
                    referrer: document.referrer || null,
                    user_agent: navigator.userAgent
                });
            } catch (error) {
                // Silently fail - don't disrupt user experience
                console.debug('Analytics tracking failed:', error);
            }
        };
        
        trackPageView();
    }, [pageName]);
};

// Track resource clicks
export const trackResourceAccess = async (resourceName, resourceUrl, category) => {
    try {
        await axios.post(`${API}/analytics/resource-access`, {
            resource_name: resourceName,
            resource_url: resourceUrl,
            category: category
        });
    } catch (error) {
        console.debug('Resource tracking failed:', error);
    }
};

// Subscribe to newsletter
export const subscribeNewsletter = async (email, name = null) => {
    const response = await axios.post(`${API}/analytics/newsletter-subscribe`, {
        email,
        name
    });
    return response.data;
};

export default usePageTracking;
